import React from "react";
import { connect } from "react-redux";
import { Row, Col, Label, Table } from "reactstrap";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { securityHelper } from "../../../../helpers/securityHelper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import FindInPageOutlinedIcon from "@material-ui/icons/FindInPageOutlined";
import { displayMoney } from "../../../../helpers/moneyHelpers";
import { handleResponse } from "../../../../helpers/handleresponse";
String.prototype.replaceHtmlEntites = function () {
  var s = this;
  var translate_re = /&(nbsp|amp|quot|lt|gt);/g;
  var translate = { nbsp: " ", amp: "&", quot: '"', lt: "<", gt: ">" };
  return s.replace(translate_re, function (match, entity) {
    return translate[entity];
  });
};

class PreConfirmation extends React.Component {
  state = {
    countries: [],
  };

  componentDidMount() {
    const { form } = this.props;
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    fetch(`./api/country/`, requestOptions)
      .then(handleResponse)
      .then((countries) => {
        let countryList = [];
        /*  setCountriesBase(countries) */
        countryList.push({ value: 0, label: "" });
        countries.map((c) => {
          countryList.push({ value: c.countryId, label: form.languageCode === "swe" || form.languageCode === undefined ? c.nameSwe : c.nameInt });
        });

        this.setState({ countries: countryList });
      });
  }

  renderPersonInformation = (order) => {
    let personFields = [];
    const fieldElements = this.props.form.formElements.filter((f) => {
      return f.type === elementConstants.FIELD && f.props.type === "Person";
    });
    if (fieldElements.length === 0) return null;
    if (!order.person) return null;
    for (const key in order.person) {
      let label = "";
      fieldElements.find((f) => {
        if (f.props.name.toLowerCase() === key.toLowerCase()) {
          label = f.props.labels[0].text;
        }
      });
      console.log('key', key, this.state.countries)
      personFields.push(
        <tr key={securityHelper.createGuid()}>
          <td style={this.props.template.content.tcell}>{label}</td>
          <td style={this.props.template.content.tcell}>{key == "countryId" ? this.state.countries.find((c) => c.value == order.person[key])?.label : order.person[key]}</td>
        </tr>
      );
    }
    return (
      <Row style={{ margin: 0 }}>
        <Col>
          <Table responsive>
            <tbody>
              {personFields.map((f) => {
                return f;
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    );
  };
  renderCompanyInformation = (order) => {
    let fields = [];
    const elements = this.props.form.formElements.filter((f) => {
      return f.type === elementConstants.FIELD && f.props.type === "Company";
    });
    if (elements.length === 0) return null;
    if (!order.company) return null;
    for (const key in order.company) {
      let label = "";
      elements.find((f) => {
        if (f.props.name.toLowerCase() === key.toLowerCase()) {
          label = f.props.labels[0].text;
        }
      });
      fields.push(
        <tr key={securityHelper.createGuid()}>
          <td style={this.props.template.content.tcell}>{label}</td>
          <td style={this.props.template.content.tcell}>{key == "countryId" ? this.state.countries.find((c) => c.value == order.company[key])?.label : order.company[key]}</td>
        </tr>
      );
    }
    return (
      <Row style={{ margin: 0 }}>
        <Col>
          <Table responsive>
            <tbody>
              {fields.map((f) => {
                return f;
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    );
  };

  renderQuestionInformation = (order) => {
    let questionFields = [];
    const questionElements = this.props.form.formElements.filter((f) => {
      return f.type === elementConstants.QUESTION;
    });

    if (questionElements.length === 0) return null;
    if (!order.answer) return null;

    order.answer.map((a, i) => {
      let question = questionElements.find((qe) => qe.id === a.questionId);
      let questionName = question.props.labels[0].text;
      let label = questionName;
      try {
        label = questionName.replace(/<[^>]*>?/gm, "");
        label = label.replaceHtmlEntites();
      } catch (error) {}
      if (a.answerRow.length > 0) {
        let options = a.answerRow.filter((ar) => ar.questionOptionId !== undefined);
        let text = a.answerRow.filter((ar) => ar.text !== undefined);

        if (text.length > 0) {
          text.map((ar, i) => {
            if (ar.text) {
              questionFields.push(
                <tr key={securityHelper.createGuid()}>
                  <td style={this.props.template.content.tcell}>{label}</td>
                  <td style={this.props.template.content.tcell}>{ar.text}</td>
                </tr>
              );
            }
          });
        }
        if (options.length > 0 && question.props.type === "Option") {
          questionFields.push(
            <tr key={securityHelper.createGuid()}>
              <td style={this.props.template.content.tcell}>{label}</td>
              <td style={this.props.template.content.tcell}>
                {question.props.options.map((o, i) => {
                  if (options.find((ox) => ox.questionOptionId === o.optionId)) {
                    return (
                      <React.Fragment key={i}>
                        <i className="fa fa-check-square" />
                        {"  "}
                        <Label>{o.labels[0].text}</Label>
                        <br />
                      </React.Fragment>
                    );
                  }
                })}
              </td>
            </tr>
          );
        }
      }
    });
    return (
      <Row style={{ margin: 0 }}>
        <Col>
          <Table responsive>
            <tbody>
              {questionFields.map((f) => {
                return f;
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    );
    /*         return questionFields; */
  };

  renderInvoiceInformation = (order) => {
    let fields = [];
    const elements = this.props.form.formElements.filter((f) => {
      return f.type === elementConstants.INVOICE_FIELD;
    });
    if (elements.length === 0) return null;
    if (!order.person) return null;
    for (const key in order.invoice) {
      let label = "";
      /*  elements.find(f => {
                 if (f.props.name.toLowerCase() === key.toLowerCase()) {
                     label = f.props.labels[0].text;
                 }
             }) */
      fields.push(
        <tr key={securityHelper.createGuid()}>
          <td style={this.props.template.content.tcell}>
            <SystemLabel groupName={"Form.Edit"} languageCode={this.props.form.languageCode || "swe"} name={key.charAt(0).toUpperCase() + key.substring(1)}></SystemLabel>
          </td>
          <td style={this.props.template.content.tcell}>{order.invoice[key]}</td>
        </tr>
      );
    }
    return (
      <Row style={{ margin: 0 }}>
        <Col>
          <Table responsive>
            <tbody>
              {fields.map((f) => {
                return f;
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    );
  };
  renderOrderInformation = (order) => {
    const { form } = this.props;
    let discounts = this.props.discounts || [];
    let ordersRows = [];
    const elements = this.props.form.formElements.filter((f) => {
      return f.type === elementConstants.EVENT;
    });
    if (elements.length === 0) return null;
    if (!order.orderRow) return null;
    if (order.orderRow.length === 1 && order.orderRow[0].eventId === form.eventId) return null;

    order.orderRow.map((or, i) => {
      let startDateTime = "";
      let endDateTime = "";
      let label = "";
      let basePrice = 0;
      let ev = or;
      if (or.eventId !== form.eventId || discounts.find((d) => d.targetEventId == or.eventId)) {
        elements.find((f) => {
          if (f.id === or.eventId) {
            startDateTime = new Date(f.props.startDateTime).toLocaleString().substring(0, 16);
            endDateTime = new Date(f.props.endDateTime).toLocaleString().substring(0, 16);
            label = f.props.name;
            basePrice = f.props.amount;
            try {
              label = label.replace(/<[^>]*>?/gm, "");
              label = label.replaceHtmlEntites();
            } catch (error) {}
          }
        });

        ordersRows.push(
          <tr>
            <td style={this.props.template.content.tcell}>{label}</td>
            {form.displayEventSettings.find((ds) => ds.name === "ShowEventStartDateTime" && ds.value === true) ? <th style={this.props.template.content.tcell}>{startDateTime}</th> : null}

            {form.displayEventSettings.find((ds) => ds.name === "ShowEventEndDateTime" && ds.value === true) ? <th style={this.props.template.content.tcell}>{endDateTime}</th> : null}
            {form.displayEventSettings.find((ds) => ds.name === "ShowEventPrice" && ds.value === true) ? (
              <td style={this.props.template.content.tcell}>{this.displayDiscountPrice(ev.amount, ev.eventId, ev.vatPercent)}</td>
            ) : null}
            <td style={this.props.template.content.tcell}>{this.displayDiscount(ev.amount, ev.eventId, ev.vatPercent, order.orderId)}</td>
            {form.displayEventSettings.find((ds) => ds.name === "ShowEventVatPrecentage" && ds.value === true) ? <td style={this.props.template.content.tcell}>{ev.vatPercent}%</td> : null}
          </tr>
        );
      }
    });

    return (
      <Row style={{ margin: 0 }}>
        <Col>
          <Table responsive>
            <thead>
              <tr>
                <th style={this.props.template.content.thead}>
                  <SystemLabel groupName={"Form.Edit"} languageCode={this.props.form.languageCode || "swe"} name={"Article"}></SystemLabel>
                </th>
                {form.displayEventSettings.find((ds) => ds.name === "ShowEventStartDateTime" && ds.value === true) ? (
                  <th style={this.props.template.content.thead}>
                    <SystemLabel groupName={"Form.Edit"} languageCode={this.props.form.languageCode || "swe"} name={"StartDateTime"}></SystemLabel>
                  </th>
                ) : null}
                {form.displayEventSettings.find((ds) => ds.name === "ShowEventEndDateTime" && ds.value === true) ? (
                  <th style={this.props.template.content.thead}>
                    <SystemLabel groupName={"Form.Edit"} languageCode={this.props.form.languageCode || "swe"} name={"EndDateTime"}></SystemLabel>
                  </th>
                ) : null}
                {form.displayEventSettings.find((ds) => ds.name === "ShowEventPrice" && ds.value === true) ? (
                  <th style={this.props.template.content.thead}>
                    <SystemLabel groupName={"Form.Edit"} languageCode={this.props.form.languageCode || "swe"} name={"Price"}></SystemLabel>
                  </th>
                ) : null}
                {form.displayEventSettings.find((ds) => ds.name === "ShowEventPrice" && ds.value === true) ? (
                  <th style={this.props.template.content.thead}>
                    <SystemLabel groupName={"Form.Edit"} languageCode={this.props.form.languageCode || "swe"} name={"Discount"}></SystemLabel>
                  </th>
                ) : null}
                {form.displayEventSettings.find((ds) => ds.name === "ShowEventVatPrecentage" && ds.value === true) ? (
                  <th style={this.props.template.content.thead}>
                    <SystemLabel groupName={"Form.Edit"} languageCode={this.props.form.languageCode || "swe"} name={"Vat"}></SystemLabel>
                  </th>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {ordersRows.map((or) => {
                return or;
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    );
  };

  displayDiscount = (price, eventId, vatPercent, orderId = null) => {
    const { form, orders, activePersonNo } = this.props;
    let discounts = this.props.discounts || [];

    let discountAmount = 0;

    if (orderId > 0 && orders.find((o) => o.orderId == orderId)?.orderRow?.find((o) => o.eventId == eventId)) {
      discountAmount = orders.find((o) => o.orderId == orderId)?.orderRow?.find((o) => o.eventId == eventId)?.discount;
    }

    if (orderId > 0) {
      discounts = orders.find((o) => o.orderId == orderId)?.discounts || [];
    }

    discounts
      .filter((d) => (d.targetEventId == eventId && d.value != 0) || (d.targetEventId == null && d.valueType == "Percent" && d.value != 0))
      .sort(function (a, b) {
        return a.value - b.value;
      })
      .map((d) => {
        discountAmount += d.valueType == "Percent" ? (price - discountAmount) * (d.value / 100) : d.value;
      });

    /*   if (discounts.length == 0 && orders[activePersonNo].orderRow?.find((o) => o.eventId == eventId)) {
      discountAmount = orders[activePersonNo].orderRow?.find((o) => o.eventId == eventId)?.discount;
    } */

    if (form.displayEventSettings.find((ds) => ds.name === "ShowEventIncVat" && ds.value === true)) {
      discountAmount = displayMoney(parseFloat(discountAmount), vatPercent);
    }
    return (
      <>
        {discountAmount} {` ${form.currency || "SEK"}`}
      </>
    );
  };

  displayDiscountPrice = (price, eventId, vatPercent) => {
    const { form } = this.props;

    const newPrice = parseFloat(form.displayEventSettings.find((ds) => ds.name === "ShowEventIncVat" && ds.value === true) ? displayMoney(parseFloat(price), vatPercent) : price);

    return (
      <>
        <span>
          {newPrice} {` ${form.currency || "SEK"}`}
        </span>
      </>
    );
  };
  render() {
    const { orders, cms } = this.props;
    if (cms.editMode)
      return (
        <div
          style={{
            width: "100%",
            height: "auto",
            padding: "10px",
            textAlign: "center",
            backgroundColor: "rgb(226, 225, 225)",
          }}
        >
          <FindInPageOutlinedIcon style={{ fontSize: "4rem", color: "#313131c2" }} />
          <br />
          <Label>
            <SystemLabel name="PreConfirmation" />
          </Label>
          <em>
            <p style={{ textAlign: "center" }} className="text-muted">
              <SystemLabel name="DoesNotShowInEditmode" />
            </p>
          </em>
        </div>
      );
    else if (orders.length === 0) return null;
    return (
      <React.Fragment>
        {orders.map((o, i) => {
          return (
            <div key={i} className="order-wrapper">
              {this.renderPersonInformation(o)}
              {this.renderCompanyInformation(o)}
              {this.renderInvoiceInformation(o)}
              {this.renderQuestionInformation(o)}
              {this.renderOrderInformation(o)}
            </div>
          );
        })}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedElement: state.form.selectedElement,
    form: state.form,
    event: state.event,
    template: state.template.template,
    cms: state.cms,
    activePersonNo: state.attendee.activePersonNo,
    orders: state.attendee.orders,
    discounts: state.attendee.orders ? state.attendee.orders[state.attendee.activePersonNo].discounts : [],
  };
}

export default connect(mapStateToProps)(PreConfirmation);
